import WorksRequest from '../ws/WorksRequest';
import WorksStateRequest from '../ws/WorksStatesRequest';
import WorkRequest from '../ws/WorkRequest';
import AddWorkRequest from '../ws/AddWorkRequest';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Alert from 'react-s-alert';
import { push } from 'react-router-redux';
import UpdateWorkRequest from '../ws/UpdateWorkRequest';
import { WORK_IMPORTED_UPDATE } from './workImportActions';
import { PsRoutes } from '../../shared/routing/Routes';

export const WORKS_UPDATE = 'works-update';
export const WORKS_LOADING = 'works-loading';
export const WORKS_ERROR = 'works-error';
export const WORKS_STATE_UPDATE = 'works-state-update';

export const WORK_ADD_LOADING = 'work-add-loading';

export const WORK_LOADING = 'work-loading';
export const WORK_ERROR = 'work-error';
export const WORK_UPDATE = 'work-update';

export const WORK_CLEAR = 'work-clear';

export const getWorks = (
    page = 1,
    search = '',
    filter = 0,
    constructions_subcontracted = false,
) => (dispatch) => {
    new WorksRequest(
        page,
        search,
        filter,
        constructions_subcontracted,
    )
        .onPreExecution(() => {
            dispatch({ type: WORKS_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: WORKS_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: WORKS_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: WORKS_LOADING, payload: false });
        })
        .execute();
};

export const getWork = (id) => (dispatch) => {

    new WorkRequest(id)
        .onPreExecution(() => {
            dispatch({ type: WORK_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: WORK_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: WORK_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: WORK_LOADING, payload: false });
        })
        .execute();
};

export const getWorksStates = () => (dispatch) => {

    new WorksStateRequest()
        .onSuccess(response => {
            // Enviamos los datos a redux
            dispatch({
                type: WORKS_STATE_UPDATE,
                payload: response,
            });
        })
        .execute();
};

export const addWork = (values) => (dispatch) => {

    new AddWorkRequest(values)
        .onPreExecution(() => {
            dispatch({ type: WORK_ADD_LOADING, payload: true });
        })
        .onSuccess(response => {
            Alert.success(I18nUtils.tr('TR_ADD_WORK_SUCCESS'));
            dispatch({ type: WORK_IMPORTED_UPDATE, payload: null });
            dispatch(push(PsRoutes.MY_OUTSOURCES_WORKS));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_ADD_WORK_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: WORK_ADD_LOADING, payload: false });
        })
        .execute();
};

export const updateWork = (values) => (dispatch) => {

    new UpdateWorkRequest(values)
        .onPreExecution(() => {
            dispatch({ type: WORK_LOADING, payload: true });
        })
        .onSuccess(response => {
            Alert.success(I18nUtils.tr('TR_UPDATE_WORK_SUCCESS'));
            dispatch(push(PsRoutes.MY_OUTSOURCES_WORKS));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_WORK_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({ type: WORK_LOADING, payload: false });
        })
        .execute();
};

export const goToAddWork = () => (dispatch) => {
    dispatch(push(PsRoutes.MY_OUTSOURCES_WORKS_ADD));
};

export const clearWork = () => (dispatch) => {
    dispatch({ type: WORK_CLEAR })
}



// WEBPACK FOOTER //
// ./src/app/works/actions/workActions.js